import React from "react"; // , {Suspense}
import { BrowserRouter as Router, Switch } from "react-router-dom";
import BaseLayOut from "@/components/BaseLayOut";
import "./App.scss";
import "./assets/font/iconfont.css";
function App() {
    return (
        <Router>
            <Switch>
                <BaseLayOut />
            </Switch>
        </Router>
    );
}

export default App;
